import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { BoltIcon, PlusIcon } from "@heroicons/react/24/outline";
import DashboardHeader from "../../../../components/dashboard/dashboardHeader";

/**
 * HSE/KS Risk Register - Overview of all risks
 */
export const HseKsRiskRegister = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    const path = location.pathname;
    if (path.includes("/matrix")) return "matrix";
    if (path.includes("/sja")) return "sja";
    if (path.includes("/climate")) return "climate";
    if (path.includes("/chemical-inventory")) return "chemical-inventory";
    if (path.includes("/protective-equipment")) return "protective-equipment";
    return "register";
  });

  const tabs = [
    { id: "register", label: "Risikoregister", path: "/dashboard/hse-ks/risk/register" },
    { id: "matrix", label: "Risikomatrise", path: "/dashboard/hse-ks/risk/matrix" },
    { id: "sja", label: "SJA", path: "/dashboard/hse-ks/risk/sja" },
    { id: "climate", label: "Klimarisiko", path: "/dashboard/hse-ks/risk/climate" },
    { id: "chemical-inventory", label: "Stoffkartotek", path: "/dashboard/hse-ks/risk/chemical-inventory" },
    { id: "protective-equipment", label: "Vernerunder", path: "/dashboard/hse-ks/risk/protective-equipment" },
  ];

  const headerActions = [
    {
      label: "Risikomatrise",
      path: "/dashboard/hse-ks/risk/matrix",
      hidden: false,
      menu: false,
    },
    {
      label: "Ny risiko",
      icon: PlusIcon,
      path: "/dashboard/hse-ks/risk/new",
      hidden: false,
      menu: false,
    },
  ];

  return (
    <DashboardHeader
      title="Risiko & SJA"
      subtitle="Risikoregister og Sikker Jobb Analyse (SJA)"
      actions={headerActions}
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          {/* Navigation Tabs */}
          <div className="bg-white shadow sm:rounded-lg">
            <div className="border-b border-gray-200 px-4 py-3 sm:px-6">
              <nav className="flex space-x-4 overflow-x-auto" aria-label="Tabs">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => {
                      setActiveTab(tab.id);
                      navigate(tab.path);
                    }}
                    className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                      activeTab === tab.id
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Risk Register List */}
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <p className="text-gray-500">Risikoregister kommer snart...</p>
            </div>
          </div>
        </div>
      </div>
    </DashboardHeader>
  );
};

